module.exports = __webpack_public_path__ + "static/simple-doughnut-e298d117a13faaa9093206b28b98261f.png";